import { Appointment } from 'src/models/appointment';
import { Document } from 'src/models/document';
import { Mail } from 'src/models/mail';
import { Memo } from 'src/models/memo';
import { Message } from 'src/models/message';
import { Note } from 'src/models/note';
import { PhoneCall } from 'src/models/phoneCall';
import { Task } from 'src/models/task';

class AggregateComparator {
	public static isEqual(
		leftAggregate: Appointment | Document | Mail | Memo | Message | Note | PhoneCall | Task | null,
		rightAggregate: Appointment | Document | Mail | Memo | Message | Note | PhoneCall | Task | null
	): boolean {
		if (leftAggregate == null && rightAggregate !== null) {
			return false;
		} else if (leftAggregate !== null && rightAggregate == null) {
			return false;
		} else if (leftAggregate == null && rightAggregate == null) {
			return true;
		} else if (leftAggregate != null && rightAggregate != null) {
			const leftParsedAggregateId = JSON.parse(leftAggregate.aggregateId) as {
				entryId: number;
				idoId: number;
				instanceId: number;
				moduleName: string;
				sourceContainerId: number;
				targetContainerId: number;
				userId: number;
			};
			const rightParsedAggregateId = JSON.parse(rightAggregate.aggregateId) as {
				entryId: number;
				idoId: number;
				instanceId: number;
				moduleName: string;
				sourceContainerId: number;
				targetContainerId: number;
				userId: number;
			};

			if (leftParsedAggregateId.moduleName !== rightParsedAggregateId.moduleName) {
				return false;
			}

			return leftParsedAggregateId.entryId === rightParsedAggregateId.entryId;
		}

		return false;
	}
}

export { AggregateComparator };
